module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Book.0759fc0b.woff";